export const createSprigLogger = (
  enabled: boolean = false,
  prefix: string = 'sprig',
) => {
  const log = (eventName: string, properties?: object, metadata?: object) => {
    if (!enabled) return

    let output = `${prefix}.${eventName}(`
    if (properties && Object.keys(properties).length) {
      output += JSON.stringify(properties, null, 2)
    }
    if (metadata && Object.keys(metadata).length) {
      if (properties && Object.keys(properties).length) {
        output += ', '
      }
      output += JSON.stringify(metadata, null, 2)
    }
    output += ')'

    console.groupCollapsed(`Sprig event: ${eventName}`) // eslint-disable-line
    console.info(`%c ${output}`, 'color: #59a2ea') // eslint-disable-line
    console.groupEnd() // eslint-disable-line
  }

  const warn = (message: string, error?: unknown) => {
    if (!enabled) return

    console.groupCollapsed(`Sprig warning`) // eslint-disable-line
    console.warn(`%c ${prefix}: ${message}`, 'color: #ff9800') // eslint-disable-line
    if (error) {
      console.error(error) // eslint-disable-line
    }
    console.groupEnd() // eslint-disable-line
  }

  return { log, warn }
}
